module.exports = __WEBPACK_EXTERNAL_MODULE__atlassiansox_cross_flow_support__;